export const NOTIFICATION_ANIMATION_MS = 350
export const NOTIFICATION_DURATION_MS = 2500
/** Visible time for objective-complete banner before exit animation (quest-complete still uses NOTIFICATION_DURATION_MS). */
export const OBJECTIVE_COMPLETE_NOTIFICATION_DURATION_MS = 4000
export const STAR_BURST_COUNT = 24
export const STAR_BURST_DISTANCE = 145
export const STAR_BURST_DURATION_MS = 750

export const STAR_ANGLES = Array.from({ length: STAR_BURST_COUNT }, (_, i) =>
  (i / STAR_BURST_COUNT) * 360
)
